import { AnimatePresence, motion } from "motion/react";
import { X } from "lucide-react";
import type { CartItem as CartItemType } from "@/src/types";
import { CartItem } from "./CartItem";
import { CartEmpty } from "./CartEmpty";
import { CartFooter } from "./CartFooter";

interface CartDrawerProps {
    isOpen: boolean;
    cart: CartItemType[];
    cartTotal: number;
    onClose: () => void;
    onRemove: (id: string) => void;
    onUpdateQuantity: (id: string, delta: number) => void;
}

export function CartDrawer({
    isOpen,
    cart,
    cartTotal,
    onClose,
    onRemove,
    onUpdateQuantity,
}: CartDrawerProps) {
    return (
        <AnimatePresence>
            {isOpen && (
                <>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={onClose}
                        className="fixed inset-0 bg-black/20 backdrop-blur-sm z-[60]"
                    />
                    <motion.div
                        initial={{ x: "100%" }}
                        animate={{ x: 0 }}
                        exit={{ x: "100%" }}
                        transition={{
                            type: "spring",
                            damping: 25,
                            stiffness: 200,
                        }}
                        className="fixed right-0 top-0 h-full w-full max-w-md bg-white z-[70] shadow-2xl flex flex-col"
                    >
                        <div className="p-6 border-b flex justify-between items-center">
                            <h2 className="font-serif text-2xl">Your Bag</h2>
                            <button onClick={onClose}>
                                <X size={24} strokeWidth={1.5} />
                            </button>
                        </div>
                        <div className="flex-1 overflow-y-auto p-6 space-y-6">
                            {cart.length === 0 ? (
                                <CartEmpty />
                            ) : (
                                cart.map((item) => (
                                    <CartItem
                                        key={item.id}
                                        item={item}
                                        onRemove={onRemove}
                                        onUpdateQuantity={onUpdateQuantity}
                                    />
                                ))
                            )}
                        </div>
                        {cart.length > 0 && <CartFooter total={cartTotal} onClose={onClose} />}
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
}
